import shortid from "shortid"
import * as Objdict from "objdict"
import Geometry from "@frog/source/utility/Geometry.js"
import * as Motions from "@frog/source/utility/Motions.js"
import Timings from "@frog/source/utility/Timings.js"
import Random from "@frog/source/utility/Random.js"

import Colors from "@frog/source/data/colors.js"
import Unit from "@frog/source/models/Unit.js"

const animations = {}
export default animations

const SPEEDUP = 1

// TODO: Update to new schema!!
animations["default"] = (step) => {
    let keyframes = []
    step.deltastages.forEach((deltastage) => {
        Objdict.forEach(deltastage.units, (deltaunit, unitKey) => {
            keyframes.push({
                "mark": 0,
                "key": unitKey
            })
            const superdeltaunit = {
                "key": unitKey,
                "mark": 250,
            }
            if(deltaunit.position != undefined
            && deltaunit.mode != "absolute") {
                superdeltaunit.position = deltaunit.position
            }
            if(deltaunit.health != undefined) {
                superdeltaunit.health = deltaunit.health
            }
            keyframes.push(superdeltaunit)
        })
    })

    return { keyframes }
}

animations["move"] = (step) => {
    return {
        "keyframes": step.deltastages.map((deltastage) => {
            return Object.values(Objdict.map(deltastage.units, (unit, unitKey) => {
                const a = step.alphastage.units[unitKey].position
                const b = step.omegastage.units[unitKey].position
                return [
                    {
                        "key": unitKey,
                        "mark": 0,
                        "position": Geometry.zero(),
                    },
                    {
                        "key": unitKey,
                        "mark": 150,
                        "timing": Timings.easeOutQuad,
                        "position": {
                            "x": b.x - a.x,
                            "y": b.y - a.y,
                            "z": b.z - a.z,
                        },
                        "motion": Motions.arc(0.5),
                    },

                    {
                        "type": "audio",
                        "mark": 0,
                        "audio": {"triggerKey": "Unit:Move"},
                    },

                    // units[deltastage.annotation.unitReference].images.sprites.move.map((frame) => {
                    //     return {
                    //         "key": deltastage.annotation.unitKey,
                    //         "mark": 150 / frame.index,
                    //         "image": frame.image,
                    //     }
                    // }),
                ]
            }))
        })
    }
}

// TODO: Update to new schema!!
animations["death"] = (step) => {
    let keyframes = []
    step.deltastages.forEach((deltastage) => {
        if(deltastage.annotation == undefined
        || deltastage.annotation.type == "death-by-damage") {
            Object.keys(deltastage.units).forEach((unitKey) => {
                keyframes = keyframes.concat([
                    {
                        "key": unitKey,
                        "mark": 0,
                        "position": Geometry.zero(),
                        "opacity": 1,
                    },
                ])
                // for(let i = 0; i < 1; i += 0.1) {
                //     keyframes.push({
                //         "mark": 0 + (i * 500),
                //         "key": unitKey,
                //         "timing": Timings.jump,
                //         "position": {
                //             "x": Random.range(-0.25, 0.25),
                //             "y": Random.range(-0.25, 0.25),
                //         },
                //     })
                // }k
                const audioKey = shortid.generate()
                keyframes = keyframes.concat([
                    {
                        "key": audioKey,
                        "type": "audio",
                        "mark": 0,
                        "audio": { "unitSound": { "unitKey": unitKey, "soundKey": "death", "default": "event:/Default/UnitDeath" } },
                    },
                    {
                        "key": unitKey,
                        "mark": 0,
                        "opacity": 1,
                        "position": Geometry.zero()
                    },
                    {
                        "key": unitKey,
                        "mark": 300,
                        "opacity": 0,
                    },
                    {
                        "key": unitKey,
                        "mark": 500,
                    }
                ])
            })
        }
        if(deltastage.annotation.type == "death-by-falling") {
            Object.keys(deltastage.units).forEach((unitKey) => {
                keyframes = keyframes.concat([
                    {
                        "type": "audio",
                        "mark": 0,
                        "audio": {"triggerKey": "Unit:Death:Falling"},
                    },
                    {
                        "key": unitKey,
                        "mark": 0,
                        "width": 10,
                        "height": 10,
                    },
                    {
                        "key": unitKey,
                        "mark": 400,
                        "timing": Timings.easeInQuad,
                        "width": 0,
                        "height": 0,
                    },


                    {
                        "key": unitKey,
                        "mark": 200,
                        "opacity": 1
                    },
                    {
                        "key": unitKey,
                        "mark": 400,
                        "timing": Timings.linear,
                        "opacity": 0
                    },
                    // {
                    //     "key": unitKey,
                    //     "mark": 0,
                    //     "rotation": 0
                    // },
                    // {
                    //     "key": unitKey,
                    //     "mark": 400,
                    //     "timing": Timings.easeInQuad,
                    //     "rotation": 60
                    // },
                ])
                // for(let i = 0; i < 1; i += 0.1) {
                //     keyframes.push({
                //         "mark": 0 + (i * 200),
                //         "key": unitKey,
                //         // "timing": Timings.jump,
                //         "position": {
                //             "x": Random.range(-0.25, 0.25),
                //             "y": Random.range(-0.25, 0.25),
                //         },
                //     })
                // }
            })
        }
    })
    return { keyframes }
}

// TODO: Update to new schema!!
animations["explode"] = (step) => {
    const CENTER_OFFSET = {"x": 0, "y": -0.5, "z": 0.2} // FOR TOP DOWN
    // const CENTER_OFFSET = {"x": -0.5, "y": -0.5, "z": 0.2}
    let keyframes = []
    step.deltastages.forEach((deltastage) => {
        if(deltastage.annotation == undefined) {
            return
        }
        if(deltastage.annotation.type == "remove") {
            // SPRITE ANIMATION
            if(units[deltastage.annotation.unitReference] != undefined
            && units[deltastage.annotation.unitReference].images != undefined
            && units[deltastage.annotation.unitReference].images.sprites != undefined
            && units[deltastage.annotation.unitReference].images.sprites.death != undefined) {
                keyframes = keyframes.concat(units[deltastage.annotation.unitReference].images.sprites.death.map((frame) => {
                    return {
                        "key": deltastage.annotation.unitKey,
                        // "mark": (deltastage.annotation.distance * 100) + frame.time,
                        "mark": (frame.time * SPEEDUP),
                        "image": frame.image,
                    }
                }))
            } else {
                keyframes.push({
                    "mark": (deltastage.annotation.distance * 50),
                    "key": deltastage.annotation.unitKey,
                    "health": -10000,
                    "isDead": true,
                    "opacity": 0,
                })
            }
        }
        if(deltastage.annotation.type == "sound") {
            keyframes.push({
                "type": "audio",
                "mark": 0,
                "audio": {"triggerKey": "Bomb:Explode"},
            })
        }
        if(deltastage.annotation.type == "explode") {
            for(let i = 0; i < 10; i += 1) {
                const key = shortid.generate()
                const scale = Random.range(2, 4)
                keyframes.push({
                    "mark": (deltastage.annotation.distance * 50) + (Math.random() * 100),
                    "key": key,
                    "type": "particle",

                    "scale": scale,
                    "position": Geometry.add(deltastage.annotation.position, CENTER_OFFSET, {
                        "x": (Random.range(0, 0.4)) * Random.sign(),
                        "y": (Random.range(0, 0.4)) * Random.sign(),
                    }),
                })
                keyframes.push({
                    "mark": (deltastage.annotation.distance * 150) + 500,
                    "key": key,
                    "type": "particle",
                    // "timing": Timings.bezier(0.3, 1-0.25, 1-0.3, 0.25),
                    // "motion": Motions.arc(),

                    "scale": 0,
                    // "image": require("@frog/source/assets/images/dragon-tactics/dot.png"),
                    "delete": true,
                })
            }
            // Objdict.forEach(deltastage.units, (unit, unitKey) => {
            //     keyframes.push({
            //         "mark": deltastage.annotation.distance * 100,
            //         "key": unitKey,
            //         "health": unit.health,
            //         "isDead": unit.isDead,
            //         "opacity": 0,
            //     })
            // })
        }
        if(deltastage.annotation.type == "spawn") {
            keyframes.push({
                "mark": (deltastage.annotation.distance * 50),
                "createUnit": deltastage.annotation.unit,
            })
        }
    })
    return { keyframes }
}

// TODO: Update to new schema!!
animations["exhaust energy"] = (step) => {
    let keyframes = []
    step.deltastages.forEach((deltastage) => {
        Object.keys(deltastage.units).forEach((unitKey) => {
            keyframes = keyframes.concat([
                {
                    "key": unitKey,
                    "mark": 0,
                    "timing": Timings.easeInQuad,
                    "grayscale": 0,
                },
                {
                    "key": unitKey,
                    "mark": 500,
                    "timing": Timings.easeInQuad,
                    "grayscale": 1,
                },
            ])
        })
    })
    return { keyframes }
}

function NudgedMovement(deltastage, mark = 0) {
    return [
        {
            "key": deltastage.annotation.unitKey,
            "mark": mark + 0,
            "position": Geometry.zero(),
        },
        {
            "key": deltastage.annotation.unitKey,
            "mark": mark + 150,
            "position": Geometry.multiply(deltastage.annotation.direction, 0.25),
            "timing": Timings.easeOutQuad,
        },
        {
            "key": deltastage.annotation.unitKey,
            "mark": mark + 200,
            "position": Geometry.zero(),
            "timing": Timings.easeInQuad,
        },
    ]
}

function PushedMovement(deltastage, mark = 0) {
    return [
        {
            "key": deltastage.annotation.unitKey,
            "mark": mark + 0,
            "position": Geometry.zero(),
        },
        {
            "key": deltastage.annotation.unitKey,
            "mark": mark + 150,
            "position": Geometry.add(deltastage.annotation.vector, Geometry.multiply(deltastage.annotation.direction, 0.25)),
            "timing": Timings.easeOutQuad,
        },
        {
            "key": deltastage.annotation.unitKey,
            "mark": mark + 200,
            "position": deltastage.annotation.vector,
            "timing": Timings.easeInQuad,
        },
    ]
}

function PushedSprites(deltastage, mark = 0) {
    if(units[deltastage.annotation.unitReference]
    && units[deltastage.annotation.unitReference].images.sprites.pushed) {
        return units[deltastage.annotation.unitReference].images.sprites.pushed.map((frame) => {
            return {
                "key": deltastage.annotation.unitKey,
                "mark": mark + (frame.time * SPEEDUP),
                "image": frame.image,
            }
        })
    }
}

function SwingBackMovement(deltastage, mark = 0) {
    return [
        {
            "key": deltastage.annotation.unitKey,
            "mark": mark + 0,
            "position": Geometry.zero(),
        },
        {
            "key": deltastage.annotation.unitKey,
            "mark": mark + 25,
            "position": Geometry.multiply(deltastage.annotation.direction, -0.25),
        },
        {
            "key": deltastage.annotation.unitKey,
            "mark": mark + 200,
            "position": Geometry.multiply(deltastage.annotation.direction, -0.25),
        },
        {
            "key": deltastage.annotation.unitKey,
            "mark": mark + 300,
            "position": Geometry.multiply(deltastage.annotation.direction, +0.125),
        },
        {
            "key": deltastage.annotation.unitKey,
            "mark": mark + 300 + 50,
            "position": Geometry.multiply(deltastage.annotation.direction, +0.125),
        },
        {
            "key": deltastage.annotation.unitKey,
            "mark": mark + 300 + 150,
            "position": Geometry.zero(),
        },
    ]
}

function AttackSprites(deltastage, mark) {
    return units[deltastage.annotation.unitReference].images.sprites.attack.map((frame) => {
        return {
            "key": deltastage.annotation.unitKey,
            "mark": frame.time * SPEEDUP,
            "image": frame.image,
        }
    })
}

import units from "@frog/source/data/units.js"

function iterations(count) {
    const array = []
    if(count < 0) {
        return array
    }
    for(let index = 0; index < count; index += 1) {
        array.push(index)
    }
    return array
}

animations["gun-burst"] = function(step) {
    const chkchkDuration = 600
    return {
        "keyframes": step.deltastages.map((deltastage) => {
            if(deltastage.annotation == undefined) return
            if(deltastage.annotation.type == "swing") {
                return [
                    // // SQUASH RELOAD
                    // {
                    //     "key": deltastage.annotation.unitKey,
                    //     "mark": 0,
                    //     "scale": {"y": 1},
                    // },
                    // {
                    //     "key": deltastage.annotation.unitKey,
                    //     "mark": chkchkDuration / 2,
                    //     "timing": Timings.linear,
                    //     "scale": {"y": 0.75},
                    // },
                    // {
                    //     "key": deltastage.annotation.unitKey,
                    //     "mark": chkchkDuration,
                    //     "scale": {"y": 1},
                    // },

                    SwingBackMovement(deltastage, chkchkDuration),
                    AttackSprites(deltastage, 0),

                    // SHOTGUN SHOT PARTICLE EFFECT
                    iterations(5).map((index) => {
                        const key = shortid.generate()
                        const offset = {"x": 0, "y": -0.5, "z": 1}
                        let direction = deltastage.annotation.direction
                        direction = Geometry.multiply(direction, 1.5)
                        direction = Geometry.rotate(direction, (index - 2) * (45 / 2))
                        return [
                            {
                                "key": key,
                                "type": "particle",
                                "mark": chkchkDuration + 0,
                                "scale": 2,
                                "position": Geometry.add(deltastage.annotation.fromPosition, offset),
                                // "rotation": 0,
                            },
                            {
                                "key": key,
                                "type": "particle",
                                "mark": chkchkDuration + 100,
                                "timing": Timings.easeOutQuad,
                                "position": Geometry.add(deltastage.annotation.fromPosition, offset, direction),
                                // "rotation": (deltastage.annotation.distance * (360 * SPEEDUP)),
                                "delete": true,
                            },
                        ]
                    }),

                    // SOUND EFFECTS
                    {
                        "type": "audio",
                        "mark": 0,
                        "audio": {"triggerKey": "Unit:Shotgun:Load"},
                    },
                    {
                        "type": "audio",
                        "mark": chkchkDuration + 0,
                        "audio": {"triggerKey": "Unit:Shotgun:Shoot"},
                    },
                ]
            }
            if(deltastage.annotation.type == "push") {
                return [
                    PushedMovement(deltastage, chkchkDuration),
                    PushedSprites(deltastage, chkchkDuration),
                ]
            }
            if(deltastage.annotation.type == "nudge") {
                return [
                    NudgedMovement(deltastage, chkchkDuration),
                    PushedSprites(deltastage, chkchkDuration),
                ]
            }
        })
    }
}

animations["gun-push"] = (step) => {
    return {
        "keyframes": step.deltastages.map((deltastage) => {
            if(deltastage.annotation == undefined) return

            const shootMark = 700
            const projectileSpeed = 50
            const hitMark = shootMark + ((deltastage.annotation.projectileDistance || 0) * projectileSpeed)

            if(deltastage.annotation.type == "swing") {
                return [
                    SwingBackMovement(deltastage, shootMark),
                    AttackSprites(deltastage, 0),

                    // PROJECTILE & TRAIL
                    iterations(5).map((index) => {
                        const key = shortid.generate()
                        const offset = {"x": 0, "y": -0.5, "z": 1}
                        return [
                            {
                                "key": key,
                                "type": "particle",
                                "mark": shootMark + (index * (projectileSpeed / 4)),
                                "scale": 3 - (index / 2),
                                "position": Geometry.add(deltastage.annotation.fromPosition, offset),
                            },
                            {
                                "key": key,
                                "type": "particle",
                                "mark": hitMark + (index * (projectileSpeed / 4)),
                                "timing": Timings.linear,
                                "position": Geometry.add(deltastage.annotation.toPosition, offset),
                                "delete": true,
                            },
                        ]
                    }),

                    // AUDIO
                    {
                        "type": "audio",
                        "mark": shootMark,
                        "audio": {"triggerKey": "Unit:PushGun:Shoot"},
                    },
                ]
            }
            if(deltastage.annotation.type == "push") {
                return [
                    PushedMovement(deltastage, hitMark),
                    PushedSprites(deltastage, hitMark),
                ]
            }
            if(deltastage.annotation.type == "nudge") {
                return [
                    NudgedMovement(deltastage, hitMark),
                    PushedSprites(deltastage, hitMark),
                ]
            }
        })
    }
}

animations["gun-pull"] = (step) => {
    return {
        "keyframes": step.deltastages.map((deltastage) => {
            if(deltastage.annotation == undefined) return

            const shootMark = 700
            const projectileSpeed = 50
            const hitMark = shootMark + ((deltastage.annotation.projectileDistance || 0) * projectileSpeed)

            if(deltastage.annotation.type == "swing") {
                return [
                    AttackSprites(deltastage, 0),

                    // AUDIO
                    {
                        "type": "audio",
                        "mark": shootMark,
                        "audio": {"triggerKey": "Unit:PullGun:Shoot"},
                    },
                ]
            }
            if(deltastage.annotation.type == "push") {
                return [
                    // SwingBackMovement(deltastage, hitMark), // TODO: This needs to be passed the performer's key in the deltastage!
                    PushedMovement(deltastage, hitMark),
                    PushedSprites(deltastage, hitMark),
                ]
            }
            if(deltastage.annotation.type == "nudge") {
                return [
                    NudgedMovement(deltastage, hitMark),
                    PushedSprites(deltastage, hitMark),
                ]
            }
        })
    }
}

animations["bomb-throw"] = (step) => {
    return {
        "keyframes": step.deltastages.map((deltastage) => {
            if(deltastage.annotation == undefined) {
                return
            }

            const shootMark = 700
            const projectileSpeed = 200
            const hitMark = shootMark + ((deltastage.annotation.projectileDistance || 0) * projectileSpeed)

            if(deltastage.annotation.type == "swing") {
                return [
                    SwingBackMovement(deltastage, shootMark),
                    AttackSprites(deltastage, 0),

                    // PROJECTILE & TRAIL
                    deltastage.annotation.startPosition != undefined
                    && deltastage.annotation.endPosition != undefined
                    && iterations(6).map((index) => {
                        const key = shortid.generate()
                        const offset = {"x": 0, "y": -0.5, "z": 1}
                        return [
                            {
                                "key": key,
                                "mark": shootMark + (33 * index),
                                "type": "particle",
                                "scale": 3 - (0.5 * index),
                                "position": Geometry.add(deltastage.annotation.fromPosition, offset),
                            },
                            {
                                "key": key,
                                "mark": hitMark + (33 * index),
                                "type": "particle",
                                "timing": Timings.bezier(0.3, 1-0.25, 1-0.3, 0.25),
                                "motion": Motions.arc(),
                                "position": Geometry.add(deltastage.annotation.toPosition, offset),
                                "delete": true,
                            },
                        ]
                    }),

                    // AUDIO
                    {
                        "type": "audio",
                        "mark": shootMark + 100,
                        "audio": {"triggerKey": "Unit:Throw"},
                    },
                ]
            }

            if(deltastage.annotation.type == "place-unit") {
                return [
                    {
                        "mark": 1200,
                        "createUnit": deltastage.annotation.unit,
                    }
                ]
            }
        })
    }
}
